import type {Pointer} from '@wix/document-services-types'
import type {SerializedVariablesList} from '../types'
import type {VariantsAPI} from '../../variants/variants'
import {DATA_TYPES} from '../../../constants/constants'

export interface IPresetsRepository {
    getRawVariablesData(): SerializedVariablesList | undefined
}

export class PresetsRepository implements IPresetsRepository {
    constructor(private readonly variantsAPI: VariantsAPI, private readonly rootWidget: Pointer) {}

    getRawVariablesData(): SerializedVariablesList | undefined {
        return this.variantsAPI.getItemConsideringVariantsForPointer(this.rootWidget, DATA_TYPES.variables)
    }
}
